const isPaidOrderStatus = (status: string | null | undefined): boolean =>
  status === "FULLY_PAID" ||
  status === "PARTIALLY_PAID" ||
  status === "PARTIALLY_REFUNDED";

type CanChangeBookingPromoCodeArgs = {
  source?: string | null;
  orderStatuses: ReadonlyArray<string | null | undefined>;
};

export const canChangeBookingPromoCode = ({
  source,
  orderStatuses,
}: CanChangeBookingPromoCodeArgs): boolean =>
  source !== "STAFF" && !orderStatuses.some(isPaidOrderStatus);
